import { Box, Skeleton } from '@chakra-ui/react';
import { AdminLayout } from '@diamond/sol-admin/components';

export function BannerLoadingSkeleton() {
  return (
    <AdminLayout>
      <Box py={4}>
        <Skeleton height="540px" borderRadius="md" />
      </Box>
    </AdminLayout>
  );
}
